<div role="row">
  <ng-content></ng-content>
</div>
